import { render, staticRenderFns } from "./AppBaseR.vue?vue&type=template&id=2a070b90&"
import script from "./AppBaseR.vue?vue&type=script&lang=js&"
export * from "./AppBaseR.vue?vue&type=script&lang=js&"
import style0 from "./AppBaseR.vue?vue&type=style&index=0&id=2a070b90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports